function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { DefaultCard, ResearchCard, FeatureCard, EditorialCard, PreviewCard } from './templates';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesArticleCard = props => {
  var article = props.article,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? () => {} : _props$onClick,
    _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'default' : _props$appearance;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var handleClick = function handleClick() {
    sendEvent('article-click', {
      article
    });
    onClick(...arguments);
  };
  var allProps = _objectSpread(_objectSpread({}, props), {}, {
    onClick: handleClick
  });
  var template;
  switch (appearance) {
    case 'research':
      template = ___EmotionJSX(ResearchCard, allProps);
      break;
    case 'feature':
      template = ___EmotionJSX(FeatureCard, allProps);
      break;
    case 'editorial':
      template = ___EmotionJSX(EditorialCard, allProps);
      break;
    case 'preview':
      template = ___EmotionJSX(PreviewCard, allProps);
      break;
    case 'default':
    default:
      template = ___EmotionJSX(DefaultCard, allProps);
      break;
  }
  return template;
};
export default AllhomesArticleCard;